import { render, staticRenderFns } from "./PreCotizacion.vue?vue&type=template&id=18e207ac&scoped=true&"
import script from "./PreCotizacion.vue?vue&type=script&lang=js&"
export * from "./PreCotizacion.vue?vue&type=script&lang=js&"
import style0 from "./PreCotizacion.vue?vue&type=style&index=0&id=18e207ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e207ac",
  null
  
)

export default component.exports